export default function SAP() {
  return (
    <>
      <svg
        width="69"
        height="35"
        viewBox="0 0 69 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>SAP</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.687 34.894H0v-34h68.702l-34.015 34zm-.673-27.611l6.723.001c6.588 0 9.545 2.306 9.545 7.329 0 4.512-3.092 7.202-8.335 7.202H39.66v6.493h-9.949l-1.075-3.105a11.062 11.062 0 01-3.496.545c-1.344 0-2.554-.21-3.63-.57l-.941 3.13h-6.185l.673-1.806a.457.457 0 00-.137.104c-.033.033-.066.067-.132.103-1.48 1.234-3.496 1.913-5.781 1.956l-.404.003c-2.689 0-5.378-.756-7.663-2.041l2.15-4.148c2.286 1.335 3.63 1.635 5.513 1.6 1.076-.023 1.748-.205 2.286-.688a1.52 1.52 0 00.403-1.054c0-1.081-1.479-1.585-3.361-2.167-1.613-.472-3.227-1.116-4.706-2.105C1.747 16.892.941 15.418.941 13.341c0-1.51.672-2.872 1.613-3.945 1.479-1.542 3.899-2.472 6.857-2.472 2.42.003 5.378.703 7.663 1.811l-2.42 4.097c-2.42-1.154-3.63-1.266-4.974-1.334-2.017-.108-2.958.613-2.958 1.398-.135.947 1.882 1.812 3.63 2.401 2.823.877 6.319 2.048 6.857 5.436l5.109-13.45h5.78l5.916 16.082V7.283zM22.99 20.668a6.06 6.06 0 002.151.385c.807 0 1.479-.132 2.151-.363l-2.151-6.787-2.151 6.765zm16.671-3.506h1.479c2.017 0 3.63-.657 3.63-2.755 0-2.04-1.613-2.7-3.63-2.7h-1.479v5.455z"
          fill="#9DA6C7"
        />
      </svg>
    </>
  );
}
